<template>
  <v-menu
    ref="menu"
    v-model="menu"
    :close-on-content-click="false"
    :return-value.sync="_value"
    transition="scale-transition"
    offset-y
    min-width="auto"
  >
    <template v-slot:activator="{}">
      <validation-provider
        v-slot="{ errors }"
        :name="fieldName"
        :rules="rules"
      >
        <v-text-field
          ref="input"
          v-model="_value"
          v-disabled-icon-focus
          color="blue"
          :error-messages="errors"
          :label="$t('fields.'+fieldName)"
          :disabled="disabled"
          v-on="$listeners"
          @blur="blur"
          @keydown="onlyLetters"
        >
          <template v-slot:append tabindex="-1">
            <v-icon
              tabindex="-1"
              @click="_value = ''"
              v-text="'mdi-close'"
            />
            <v-btn
              small
              tabindex="-1"
              icon
              @click="menu = !menu"
            >
              <v-icon v-text="'mdi-clock'" />
            </v-btn>
          </template>
        </v-text-field>
      </validation-provider>
    </template>
    <v-time-picker
      v-if="menu"
      v-model="_value"
      format="24hr"
      @click:minute="$refs.menu.save(_value)"
    />
  </v-menu>
</template>

<script>
  import moment from 'moment'

  export default {
    name: 'TimeField',
    directives: {
      disabledIconFocus: {
        bind (el) {
          el.querySelectorAll('.v-input__icon button').forEach(x => x.setAttribute('tabindex', -1))
        },
      },
    },
    model: {
      prop: 'timeValue',
      event: 'valuechange',
    },
    props: {
      timeValue: String,
      fieldName: String,
      rules: String,
      disabled: Boolean,
    },
    data: vm => ({
      menu: false,
    }),
    computed: {
      _value: {
        get: function () {
          return this.timeValue
        },
        set: function (value) {
          // console.log(value.replace(/[^\d|:]/g, ''))
          this.$emit('valuechange', value)
        },
      },
    },
    methods: {
      blur (e) {
        let value = this._value ?? ''
        // console.log(value.length)
        if (value.indexOf(':') !== -1) {
          value = value.split(':')[0].padStart(2, '0') + ':' + value.split(':')[1].padStart(2, '0')
        } else {
          switch (value.length) {
            case 1:
              value = '00:0' + value
              break
            case 2:
              value = '00:' + value
              break
            case 3:
              value = ['0', value.slice(0, 1), ':', value.slice(1)].join('')
              break
            case 4:
              value = [value.slice(0, 2), ':', value.slice(2)].join('')
              break
          }
        }
        this._value = value
      },
      onlyLetters (e) {
        const selector = this.$refs.input.$el.querySelector('input')
        const selectionStart = selector.selectionStart
        const selectionEnd = selector.selectionEnd
        const length = (this._value ?? '').replace(':', '').length

        const time = moment(this._value === '' ? '00:00' : this._value ?? '00:00', 'HH:mm')
        // console.log(moment('00:00', 'HH:mm').format('HH:mm'))
        // console.log(moment('00:00', 'HH:mm').isValid())
        if ([33, 34, 38, 40].indexOf(e.keyCode) !== -1) {
          if (time.isValid()) {
            switch (e.keyCode) {
              case 33:
                this._value = time.add(1, 'hour').format('HH:mm')
                break
              case 34:
                this._value = time.add(-1, 'hour').format('HH:mm')
                break
              case 38:
                this._value = time.add(1, 'minute').format('HH:mm')
                break
              case 40:
                this._value = time.add(-1, 'minute').format('HH:mm')
                break
            }
          }
          e.preventDefault()
          return
        }

        // Allow: Numbers
        if (
          ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'].indexOf(e.key) !== -1 &&
          (length < 4 || selectionStart !== selectionEnd)
        ) {
          return
        }

        if (length === 2 && e.keyCode === 9 && (this._value ?? '').indexOf(':') === -1) {
          this._value += ':00'
          // this.$refs.input.focus()
          this.$refs.input.$el.value += ':00'
          // console.log(this.$refs.input.$el.value)
          this.$nextTick(() => {
            // DOM is now updated
            // `this` is bound to the current instance
            selector.setSelectionRange(3, 5)
          })
          e.preventDefault()
          return
        }

        if (
          // (['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'].indexOf(e.key) !== -1) ||
          // Allow: Numbers
          (e.key === ':' && (this._value ?? '').indexOf(':') === -1) ||
          // Allow: first [:]
          [46, 8, 9, 27, 13, 110, 190].indexOf(e.keyCode) !== -1 ||
          // Allow: Ctrl+A
          (e.keyCode === 65 && e.ctrlKey === true) ||
          // Allow: Ctrl+C
          (e.keyCode === 67 && e.ctrlKey === true) ||
          // Allow: Ctrl+V
          (e.keyCode === 86 && e.ctrlKey === true) ||
          // Allow: Ctrl+X
          (e.keyCode === 88 && e.ctrlKey === true) ||
          // Allow: home, end, up, down, left, right
          (e.keyCode >= 35 && e.keyCode <= 40)) {
          // let it happen, don't do anything
          return
        }

        // Ensure that it is other and stop the keypress
        e.preventDefault()
      },
      filterKey (e) {
        const key = e.key

        // console.log(e)

        // If is '.' key, stop it
        if (key === '.') {
          return e.preventDefault()
        }

        if (key === ':' && (this._value ?? '').indexOf(':') !== -1) {
          return e.preventDefault()
        }

        // OPTIONAL
        // If is 'e' key, stop it
        if (
          !this.isNumeric(key) &&
          key !== 'Backspace' &&
          key !== 'Delete' &&
          key !== 'Tab' &&
          key !== ':' &&
          key.indexOf('Arrow') === -1
        ) {
          // if (key === 'e') {
          return e.preventDefault()
        }
      },
      isNumeric (value) {
        console.log(value)
        return Number.isInteger(Number.parseInt(value))
      },
      checknum: function (event) {
        this._value = this._value.replace(/[^0-9]/g, '')
      },
      // This can also prevent copy + paste invalid character
      filterInput ($event) {
        console.log($event)
        // e.target.value = e.target.value.replace(/[^0-9]+/g, '')
      },
    },
  }
</script>
